<div *ngIf="client" style="margin:20px 0">
    <div class="h4 black" style="margin-bottom: 8px;">Available Skill Rating Types</div>
    <app-editable-table #skillRatings class="skillRatings sms-editable-table" [canEdit]="canEdit"
        [columns]="skillRatingsColumns" [dataSource]="settings.skillRatings"
        [footNotes]="'Weightage needs to be between 1 and 10, 10 being the highest'" [saveButtonText]="'Save'"
        (onSave)="saveData($event)">
    </app-editable-table>
</div>